<template>
    <div>
        <v-file-viewer ref="fileViewer"></v-file-viewer>

        <b-modal id="upload-file" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <employee-sicil-file-upload v-model="file" :errors="errors" :types="documentTypes"></employee-sicil-file-upload>
            <template #modal-footer><v-executer :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-table
            ref="table"
            :fields="fields"
            :buttons="buttons"
            :add-callback="createNew"
            name="employee-documents"
            :items-provider="provider"
            :initial-load="id != '0' || id != 0 ? true : false"
            :settings="false"
        ></v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from "@/api/employee-operations";
import Additional from "@/utilities/additional";
import EmployeeSicilFileUpload from "./components/EmployeeSicilFileUpload.vue";
import VFileViewer from "@/components/VFileViewer.vue";

export default {
    components: {
        EmployeeSicilFileUpload,
        VFileViewer,
    },
    props: {
        id: [String, Number],
        code: [String, Number],
    },
    data() {
        return {
            fields: [
                { name: "Dosya Türü", key: "Name", sortable: true, thClass: "w-50" },
                { name: "Yükleme Tarihi", key: "CreateTime", sortable: true, thClass: "w-50" },
            ],
            buttons: [
                { text: "İndir", key: "download", icon: "DownloadIcon", variant: "primary", action: this.download },
                { text: "Görüntüle", key: "view", icon: "EyeIcon", variant: "success", action: this.view },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.delete },
            ],
            loading: false,
            file: {
                Id: null,
                EmployeeId: null,
                File: null,
                SystemCode: null,
            },
            errors: {},
            documentTypes: [],
        };
    },
    watch: {
        id() {
            this.$refs.table?.refresh();
        },
        code: {
            handler(val) {
                if (val) {
                    this.getDocumentTypes();
                }
            },
            immediate: true,
        },
    },
    methods: {
        getDocumentTypes() {
            EmployeeOperationsApi.Employee.EmployeeSicilBelge.GetTypesByCollarStatus(this.code).then((res) => {
                const dataObject = res.data.Data;
                this.documentTypes = Object.keys(dataObject).map((key) => {
                    return { SystemCode: key, Name: dataObject[key] };
                });
            });
        },
        clearForm() {
            this.file.Id = null;
            this.file.EmployeeId = null;
            this.file.File = null;
            this.file.SystemCode = null;
        },
        provider(data) {
            return EmployeeOperationsApi.Employee.EmployeeSicilBelge.List(this.id);
        },
        refresh() {
            this.$refs.table.refresh();
        },
        createNew() {
            this.clearForm();
            this.$showModal("upload-file");
        },
        download(item) {
            this.$refs.table.rowLoading(true);

            const fileExtension = item.ApiFilePath.split(".").pop();
            const fileName = `${item.Name}.${fileExtension}`;

            Additional.GetBlobFile(item.ApiFilePath)
                .then((res) => {
                    Additional.DownloadFile(res.data, fileName);
                    this.$refs.table.rowLoading(false);
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.$refs.table.rowLoading(false);
                });
        },
        view(item) {
            this.$refs.fileViewer.view(item.ApiFilePath);
        },
        async uploadFile() {
            this.loading = true;
            this.file.EmployeeId = this.id;
            let formData = await Additional.ToFormData(this.file, ["File"]);
            EmployeeOperationsApi.Employee.EmployeeSicilBelge.Upload(formData)
                .then((res) => {
                    this.$result(res);
                    this.loading = false;
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.$hideModal("upload-file");
                    }
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        delete(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem '${item.Name}' türlü dosyayı silecektir ve geri alınamaz.`).then((result) => {
                if (result) {
                    EmployeeOperationsApi.Employee.EmployeeSicilBelge.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
    },
};
</script>

<style></style>
